import { render, staticRenderFns } from "./NewRealEstateCoordinationView.vue?vue&type=template&id=7be01ddc&scoped=true&"
import script from "./NewRealEstateCoordinationView.vue?vue&type=script&lang=js&"
export * from "./NewRealEstateCoordinationView.vue?vue&type=script&lang=js&"
import style0 from "./NewRealEstateCoordinationView.vue?vue&type=style&index=0&id=7be01ddc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7be01ddc",
  null
  
)

export default component.exports